var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppView',{attrs:{"padd-bottom":""}},[_c('TopNav',{attrs:{"slot":"top-app-view","title":"Frequently Asked Questions For Mentors","title-class":"lg:ml-body lg-app:tw-font-bold","type":"menu"},on:{"input":function($event){return _vm.openSideNav()}},slot:"top-app-view"}),_c('FAQMentor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }